import { UserGroup } from "../Components/index.js";

export default [
    {
        path: "/admin/rp/setting/group",
        component: UserGroup,
        name: "rp.setting.group",
        meta: {
            requiresAuth: true,
        },
    },
];
